<template>
  <section class="section">
    <div class="container">
      <header class="header columns">
        <div class="column"><h1 class="title">Claims Management</h1></div>
      </header>
      <AccountInfo :data="items"></AccountInfo>
    </div>
    <div class="container">
      <hr />
      <div class="fnol-form" id="fnol">
        <h1 class="title">File a Claim</h1>
        <FNOL></FNOL>
      </div>
    </div>
  </section>
</template>

<script>
import AccountInfo from '../../components/account/AccountInfo';
import FNOL from '@/components/account/FNOL.vue';

export default {
  name: 'Claims',
  data() {
    return {
      items: [
        {
          id: 'file-a-claim',
          isAlwaysOpen: true,
          content:
            '<p>If you have been in an accident, our first priority is your safety. Please get to a safe location and call the police or 911 if you need emergency assistance. As soon as you are safely able, you may start your claim by ' +
            'completing the form below. A Claims Concierge will contact you ' +
            'within one business day.</p><p>As soon as you are safely able, call <a href="tel:1-' +
            this.$phoneNumber +
            '">' +
            this.$phoneNumber +
            '</a> to speak with a claims concierge.</p><p>Your claims concierge will need the following information to get your claim started:</p><ul><li>Names and phone numbers of people involved as well as any witnesses</li><li>Drivers license numbers and insurance information for any people involved</li><li>License plate numbers and states for any vehicles involved</li><li>Photos of the vehicles involved as well as the scene of the accident</li></ul>'
        }
      ]
    };
  },
  components: {
    FNOL,
    AccountInfo
  }
};
</script>

<style lang="scss" scoped>
.title {
  margin-bottom: -0.5rem;
  margin-top: 5rem;
}
</style>
